import { SetStateAction, useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import {
  RecipePresetSubstep,
  settingsInterface,
} from '../../../app/recipeCreation/createRecipe.types';
import useLogRecipeEdit from '../../../hooks/useLogRecipeEdit';
import { EventLogsEnum } from '../../../utils/events';
import { resizeImageIfCloudinary } from '../../../utils/images/cloudinaryUtils';
import styles from './presetsView.module.css';

const PresetsView = ({
  isPresetOpen,
  setIsPresetOpen,
  settings,
  setSettings,
  presetSelected,
  setPresetSelected,
  presetsData,
}: {
  isPresetOpen: boolean;
  setIsPresetOpen: React.Dispatch<SetStateAction<boolean>>;
  settings: Array<settingsInterface>;
  setSettings: React.Dispatch<SetStateAction<Array<settingsInterface>>>;
  presetSelected: RecipePresetSubstep | null;
  setPresetSelected: React.Dispatch<SetStateAction<RecipePresetSubstep | null>>;
  presetsData: any;
}) => {
  const [showAll, setShowAll] = useState(false);
  const { logRecipeEdit } = useLogRecipeEdit();

  const handlePresetClick = (item: RecipePresetSubstep) => {
    setPresetSelected(item);
    setSettings(item?.SubstepsE3?.parameters?.settings ?? []);
    setIsPresetOpen(true);
    const selectedPresetId = item?.id;
    const subStepId = item?.subStepId;
    logRecipeEdit(EventLogsEnum.APP_PRESET_APPLIED, {
      eventData: { selectedPresetId, subStepId },
    });
  };

  const handleViewMore = () => {
    setShowAll(!showAll);
  };

  const enterManually = () => {
    setIsPresetOpen(false);
    setPresetSelected(null);
    setSettings([]);
    logRecipeEdit(EventLogsEnum.APP_MANUAL_INSTRUCTION);
  };

  return (
    <Grid className={styles.main_grid} container spacing={4}>
      {presetsData
        ?.slice(0, showAll ? presetsData?.length : 8)
        .map((item: RecipePresetSubstep, id: any) => (
          <Grid
            className={styles.preset_layout}
            container
            direction="column"
            key={item.id}
            xs={4}
          >
            <Box
              className={styles.preset_box}
              onClick={() => handlePresetClick(item)}
            >
              <Avatar
                className={styles.preset_image}
                src={resizeImageIfCloudinary(item.image, 60, 60, 60, 60, true)}
              />
              <Typography
                className={styles.preset_text}
                variant="caption4Light"
              >
                {item.name}
              </Typography>
            </Box>
          </Grid>
        ))}
      {presetsData?.length >= 8 && (
        <Grid className={styles.preset_layout} container direction="column"
          xs={4}>
          <Box className={styles.preset_box}>
            <Avatar className={styles.preset_image} onClick={handleViewMore}>
              {showAll ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </Avatar>
            <Typography className={styles.preset_text} variant="caption4Light">
              {showAll ? 'View Less' : 'View More'}
            </Typography>
          </Box>
        </Grid>
      )}
      <Grid className={styles.text_button_grid} container direction="column">
        <Typography
          className={styles.text_button}
          onClick={enterManually}
          variant="caption3Light"
        >
          Enter Manually
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PresetsView;
